import {Component, OnInit, inject, DestroyRef} from '@angular/core';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {EventsManager} from 'src/app/services/events.manager';
import {PhonePipe} from 'src/app/pipes/phone.pipe';
import {ErrorBannerComponent} from 'src/app/components/error-banner/error-banner.component';
import {NgIf} from '@angular/common';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  imports: [NgIf, ErrorBannerComponent, PhonePipe]
})

export class HeaderComponent implements OnInit {
  private _destroyRef = inject(DestroyRef);
  public eventsManager = inject(EventsManager);

  public info: any = {};
  public isAdminBy: string = '';
  public hideHeader: boolean = false;

  public ngOnInit(): void {
    this.eventsManager.contactInfoUpdated
      .pipe(takeUntilDestroyed(this._destroyRef))
      .subscribe(() => {
        this.info = this.eventsManager.contactInfo;
      });

    this.eventsManager.isAdminByUpdated
      .pipe(takeUntilDestroyed(this._destroyRef))
      .subscribe((isAdminBy: string) => {
        this.isAdminBy = isAdminBy;
      });

    this.hideHeader = this.eventsManager.hideTopHeader;

    this.eventsManager.hideHeader
      .pipe(takeUntilDestroyed(this._destroyRef))
      .subscribe((hideHeader: boolean) => {
        this.hideHeader = hideHeader;
      });
  }
}
